<template>
  <div>
    <router-view></router-view>
    <!-- <Footer></Footer> -->
  </div>
</template>
<script>
    import Footer from "@/components/footer_fair";
    export default {
        name: "fair",
        components: {Footer},
        data() {
            return {
            }
        },
        watch: {
           
        },
        created(){
         
        },
        mounted: function () {
          
        },
        methods: {
       
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/map.vue